import { toast } from 'react-toastify';

// A 403 from the API used to surface as a toast ("Insufficient permissions")
// raised by whichever saga made the call. It disappeared after a few seconds
// and left the page blank, with no hint of what was missing.
//
// The axios interceptor now announces those refusals here, the route wrapper
// listens and shows the Access Denied page instead, and the matching toasts are
// dismissed so the same thing isn't reported twice.

const PERMISSION_MESSAGE = /insufficient permission|permission denied|access denied|not authorized|unauthorized to|forbidden/i;

/** True when a message is the API refusing on permissions rather than a real error. */
export const isPermissionMessage = (message) =>
    typeof message === 'string' && PERMISSION_MESSAGE.test(message);

const listeners = new Set();

/** Called by the axios interceptor when a request comes back 403. */
export const emitAccessDenied = (detail = {}) => {
    listeners.forEach((fn) => {
        try { fn(detail); } catch (_) { /* a broken listener must not break the response */ }
    });
};

/** Subscribe to 403s; returns an unsubscribe function. */
export const subscribeAccessDenied = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};

// Sagas call toast.error directly in ~30 places, so the toast is suppressed
// centrally rather than edited into each one. react-toastify reports every new
// toast here and lets us dismiss it again before it is read.
let filterInstalled = false;
export const installPermissionToastFilter = () => {
    if (filterInstalled) return;
    filterInstalled = true;
    toast.onChange((payload) => {
        if (payload?.status !== 'added') return;
        const { content } = payload;
        const text = typeof content === 'string'
            ? content
            : (typeof content?.props?.children === 'string' ? content.props.children : '');
        if (isPermissionMessage(text)) toast.dismiss(payload.id);
    });
};
